export const defaultModals = {
	confirm: () => (import('./confirm')),
}